import React from "react";
import styles from "./FHIRPatient.module.scss";
import RecordOverrideOptions from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideOptions";
import { overrideSummaryForMultipleBirth } from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideUtil";
import { handleMultipleAttributeOverrideSingleValued } from "../../routes/NewSearchRecords/SearchRecordTable/MultipleAttributeOverride/Utils";
import Modal from "../../components/ModalPopup";
import ButtonList from "../../components/ButtonList";
import Button from "../../components/Button";
import OverrideAuditInputModal from "../../routes/NewSearchRecords/SearchRecordTable/OverrideAuditInputModal";
import {
  multipleBirthOverriddenByString,
  multipleBirthOverrideReasonString,
  multipleBirthOverrideTimestampString
} from "../../routes/NewSearchRecords/SearchRecordTable/GoldenRecordExclusion/Utils";

const MultipleBirth = ({
  data,
  summary: isSummary,
  oncRecordOverrideIconClick,
  overrideExtension,
  isInvisible = false,
  isMultipleAttributeOverride = false,
  setAttributeOverrides,
  attributeOverrides
}) => {
  const [
    replaceRecordOverrideDialog,
    setReplaceRecordOverrideDialog
  ] = React.useState(false);
  const [
    recordOverrideDialogContent,
    setRecordOverrideDialogContent
  ] = React.useState({});
  const [value, setValue] = React.useState("");
  const [valueChanged, setValueChanged] = React.useState(false);
  const [showAuditModal, setShowAuditModal] = React.useState(false);
  const [pendingConfirmDetails, setPendingConfirmDetails] = React.useState(
    null
  );

  if (isSummary) {
    if (typeof data === "boolean" && data === true) {
      return <div>Multiple Birth</div>;
    }
    return <div>Multiple Birth: {data}</div>;
  }

  const multipleBirthMap = {
    Field: "Multiple Birth",
    "Multiple Birth":
      data !== undefined
        ? typeof data === "boolean"
          ? data
            ? "Yes"
            : "No"
          : `Order: ${data}`
        : "-",
    "Mark as": "",
    originalFieldName: "multipleBirthBoolean",
    originalFieldData: data,
    originalFieldDataCopy: data
  };
  const prepareOverrideOriginalValue = type => {
    const extensionMap = overrideSummaryForMultipleBirth(
      data,
      combinedOverrideExtension,
      type
    );
    oncRecordOverrideIconClick(extensionMap);
  };

  const actionHandler = detailsMap => {
    if (isMultipleAttributeOverride) {
      handleMultipleAttributeOverrideSingleValued(
        detailsMap,
        "multipleBirth",
        attributeOverrides,
        setAttributeOverrides
      );
      setReplaceRecordOverrideDialog(false);
    } else {
      oncRecordOverrideIconClick(detailsMap);
    }
  };

  const handleReplaceOverride = detailsMap => {
    if (detailsMap["Mark as"] && detailsMap["Mark as"] === "Replace") {
      if (detailsMap.originalFieldData) {
        setValue(detailsMap.originalFieldData);
      }
      setRecordOverrideDialogContent(detailsMap);
      setReplaceRecordOverrideDialog(true);
    } else {
      actionHandler(detailsMap);
    }
  };

  const handleConfirm = () => {
    const detailsMap = { ...recordOverrideDialogContent };
    detailsMap.originalFieldData = value;
    if (isMultipleAttributeOverride)
      // Directly proceed to next step without audit modal
      actionHandler(detailsMap);
    else {
      setPendingConfirmDetails(detailsMap);
      setShowAuditModal(true);
    }
  };

  const handleAuditSubmit = auditInfo => {
    if (pendingConfirmDetails) {
      const updatedDetails = {
        ...pendingConfirmDetails,
        auditInfoList: auditInfo
      };
      actionHandler(updatedDetails);
      setPendingConfirmDetails(null);
    }
    setShowAuditModal(false);
  };

  const multipleBirthAuditUrls = [
    multipleBirthOverriddenByString,
    multipleBirthOverrideReasonString,
    multipleBirthOverrideTimestampString
  ];

  const multipleBirthAuditExtensions = (overrideExtension || []).filter(e =>
    multipleBirthAuditUrls.includes(e.url)
  );

  // Combine main overrideExtension with the audit extensions, avoiding duplicates
  const combinedOverrideExtension = [
    ...(overrideExtension || []),
    ...multipleBirthAuditExtensions.filter(
      auditExt =>
        !(overrideExtension || []).some(mainExt => mainExt.url === auditExt.url)
    )
  ];

  const replaceOverrideModal = () => {
    return (
      <Modal
        open={replaceRecordOverrideDialog}
        onClose={() => setReplaceRecordOverrideDialog(false)}
      >
        <h3 style={{ textAlign: "center" }}>Replace override</h3>
        <br />
        <br />
        <div>
          {recordOverrideDialogContent && (
            <table className={"recOvrTable"}>
              <tr>
                <td>Multiple Birth</td>
              </tr>
              <tr>
                <td>
                  <select
                    type="boolean"
                    value={value}
                    onChange={e => {
                      setValue(e.target.value === "true");
                      if (!valueChanged) {
                        setValueChanged(true);
                      }
                    }}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </td>
              </tr>
            </table>
          )}
        </div>
        <br />
        <br />
        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button
              primary
              disabled={!valueChanged}
              onClick={() => handleConfirm()}
            >
              Confirm Changes
            </Button>
            <Button
              onClick={() => {
                setValueChanged(false);
                setReplaceRecordOverrideDialog(false);
              }}
            >
              Cancel
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  return (
    <>
      {showAuditModal && (
        <OverrideAuditInputModal
          isOpen={showAuditModal}
          onCancel={() => {
            setShowAuditModal(false);
            setPendingConfirmDetails(null);
          }}
          onSubmit={handleAuditSubmit}
        />
      )}
      <div>
        <h4>Multiple Birth</h4>
        <div>
          {data !== undefined
            ? typeof data === "boolean"
              ? data
                ? "Yes"
                : "No"
              : `Order: ${data}`
            : "-"}
        </div>
      </div>
      {oncRecordOverrideIconClick && !isInvisible && typeof data === "boolean" && (
        <div className={styles.actionColumn}>
          <h4>Action</h4>
          <RecordOverrideOptions
            detailsMap={multipleBirthMap}
            onClickRecordOverrideAction={detailsMap =>
              handleReplaceOverride(detailsMap)
            }
            disableInactiiveAndInvalid={true}
            onClickRecordOverrideButton={type =>
              prepareOverrideOriginalValue(type)
            }
            extension={combinedOverrideExtension}
            isMultipleAttributeOverride={isMultipleAttributeOverride}
            selectedOverrides={attributeOverrides.multipleBirth}
          />
        </div>
      )}
      {replaceOverrideModal()}
    </>
  );
};

export default MultipleBirth;
